module.exports = __webpack_public_path__ + "static/media/closeSidebar.fb67b123.svg";